import React, { FC } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import {
    animationSpeed,
    skeletonBackgroundColor,
    skeletonForegroundColor, textBlockBorderRadius,
} from '~/src/components/skeletons/knowledge-base-banners-skeleton/knowledge-base-banners-skeleton.constants';
import * as Styled from './description-block-loader.styles';

interface DescriptionBlockLoaderProps extends IContentLoaderProps {
    height?: number;
}

export const DescriptionBlockLoader: FC<DescriptionBlockLoaderProps> = ({ height, ...restProps }) => (
    <ContentLoader
        speed={animationSpeed}
        width={'100%'}
        height={'100%'}
        backgroundColor={skeletonBackgroundColor}
        foregroundColor={skeletonForegroundColor}
        {...restProps}
    >
        <Styled.TextBlockRect x="0" y="0" rx={textBlockBorderRadius} ry={textBlockBorderRadius} height={height} />
    </ContentLoader>
);
